/** Widget の「デジタネタウンにもどる」（navigate:town）でタウンへ戻る */
export const navigateToDigitaneTown = (): void => {
  window.location.replace(`${import.meta.env.VITE_DIGITANE_ONLINE_URL}/s/`)
}
